(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-clone"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(function(question) {
      question.addEventListener('click', function() {
        const answer = this.nextElementSibling;
        const icon = this.querySelector('.faq-icon');
        const isOpen = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other FAQs
        faqQuestions.forEach(function(otherQuestion) {
          if (otherQuestion !== question) {
            otherQuestion.setAttribute('aria-expanded', 'false');
            otherQuestion.nextElementSibling.style.display = 'none';
          }
        });
        
        // Toggle current FAQ
        if (isOpen) {
          this.setAttribute('aria-expanded', 'false');
          answer.style.display = 'none';
        } else {
          this.setAttribute('aria-expanded', 'true');
          answer.style.display = 'block';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-full-page"]) return;
  try {
    
  // FAQ Page Accordion functionality - completely separate from homepage
  document.addEventListener('DOMContentLoaded', function() {
    const faqPageQuestions = document.querySelectorAll('.faq-page-question');
    
    faqPageQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const answer = this.nextElementSibling;
        
        // Toggle current item
        this.setAttribute('aria-expanded', !isExpanded);
        
        if (isExpanded) {
          answer.style.display = 'none';
        } else {
          answer.style.display = 'block';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile Menu Toggle
  document.addEventListener('DOMContentLoaded', function() {
    const menuBtn = document.querySelector('.mobile-menu-btn');
    const nav = document.querySelector('.header__nav');
    const navLinks = document.querySelectorAll('.header__nav .nav-link');
    
    if (menuBtn && nav) {
      // Toggle menu on button click
      menuBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        menuBtn.classList.toggle('active');
        nav.classList.toggle('active');
        
        // Prevent body scroll when menu is open
        if (nav.classList.contains('active')) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
      
      // Close menu when clicking on a nav link
      navLinks.forEach(link => {
        link.addEventListener('click', function() {
          menuBtn.classList.remove('active');
          nav.classList.remove('active');
          document.body.style.overflow = '';
        });
      });
      
      // Close menu when clicking outside
      document.addEventListener('click', function(event) {
        const isClickInsideMenu = nav.contains(event.target);
        const isClickOnButton = menuBtn.contains(event.target);
        
        if (!isClickInsideMenu && !isClickOnButton && nav.classList.contains('active')) {
          menuBtn.classList.remove('active');
          nav.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
